<template>
  <div class="yinsi_page">
    <!-- 返回按钮 + 标题 -->
    <div class="nav_bar">
      <div class="back_btn" @click="goBack">‹</div>
      <div class="nav_title">座享乐舒隐私政策协议</div>
    </div>

    <div class="content">
      <h1>座享乐舒隐私政策协议</h1>

      <h2>用户注册及使用软件平台隐私协议</h2>

      <p>欢迎您使用本平台各项点播服务！</p>

      <p class="indent">在此特别提醒您（用户）在注册成为用户之前，请认真阅读本协议，确保您充分理解本协议中各条款。您须审慎阅读并选择接受或不接受本协议。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。</p>

      <p class="indent">本协议约定 <strong>座享乐舒</strong>（以下简称"运营方"）与用户之间关于本平台软件服务（以下简称"服务"）的权利义务。"用户"是指注册、登录、使用本服务的个人。本协议可由运营方随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知。但在修改协议条款后，如果用户不接受修改后的条款，请立即停止使用本软件提供的服务，用户继续使用服务将被视为接受修改后的协议。</p>

      <h3>一、用户个人隐私信息保护</h3>

      <p>1. 本平台严格按照法律法规保护用户个人隐私，包括但不限于用户姓名、肖像、身份证号码等个人信息，承诺不恶意采集用户的个人信息。如果本平台发现收到他人举报或投诉用户违反本协议约定的，本平台有权进行审查、删除，并视情节轻重对违规账号处以包括但不限于警告、账号封禁、设备封禁、功能封禁的处罚，且通知用户处理结果。</p>

      <p>2. 因违反用户协议被封禁的用户，可以自行与本平台联系，其中，被实施功能封禁的用户会在封禁期满后自动恢复封禁功能。被封禁用户可提交申诉，本平台将对申诉进行审查，并自行合理判断决定是否变更处罚措施。</p>

      <p>3. 用户理解并同意，本平台有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应承担由此而产生的一切法律责任。</p>

      <p>4. 用户理解并同意，因用户违反本协议约定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户应当赔偿本平台与合作公司、关联公司，并使之免受损害。</p>

      <h3>二、其他</h3>

      <p>1. 运营方保留一切对本协议解释的权利。</p>

      <p>2. 本协议的效力、解释及纠纷的解决，适用于中华人民共和国法律。若用户和本平台之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户同意将纠纷或争议提交本平台运营方住所地有管辖权的人民法院管辖。</p>

      <p>3. 本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效，对双方具有约束力。</p>
    </div>

    <AdultNewTabBar />
  </div>
</template>

<script>
import AdultNewTabBar from '@/components/AdultNewTabBar.vue'

export default {
  name: 'NewPageYinsi',
  components: { AdultNewTabBar },
  methods: {
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.yinsi_page {
  width: 100vw;
  min-height: 100vh;
  background: #f5f8fc;
  box-sizing: border-box;
  padding-bottom: 70px;
}

/* 顶部导航 */
.nav_bar {
  position: relative;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.back_btn {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 28px;
  color: #2c6ba5;
  font-weight: 300;
  cursor: pointer;
  line-height: 1;
}
.nav_title {
  font-size: 16px;
  font-weight: 600;
  color: #1a3c5e;
}

/* 内容区 */
.content {
  margin: 12px 14px;
  padding: 18px 16px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
  color: #333;
  font-size: 14px;
  line-height: 1.9;
}
.content h1 {
  font-size: 18px;
  font-weight: 700;
  color: #1a3c5e;
  text-align: center;
  margin: 0 0 18px;
}
.content h2 {
  font-size: 15px;
  font-weight: 700;
  color: #1a3c5e;
  margin: 20px 0 10px;
}
.content h3 {
  font-size: 14px;
  font-weight: 700;
  color: #1a3c5e;
  margin: 18px 0 8px;
}
.content p {
  margin: 0 0 10px;
  text-align: justify;
}
.content p.indent {
  text-indent: 2em;
}
.content strong {
  color: #2c6ba5;
}
</style>
